import { createSlice } from "@reduxjs/toolkit";


export const SelectMainLoader = ({ loaderlice }) => loaderlice.mainLoaderFlag



const loaderSlice = createSlice({
    name: "loaderSlice",
    initialState: {
        mainLoaderFlag : true
    },
    reducers: {
        SET_MAIN_LOADER: (state, { payload }) => { state.mainLoaderFlag = payload },
    }
})





export const {
    SET_MAIN_LOADER

} = loaderSlice.actions;

export default loaderSlice.reducer;